import axios from 'axios'

export default class BeneficiarioCadbenefService {
  constructor (tokenBearer, url) {
    this.url = `${url}/api/cadbenef/competencia/beneficiarios`
    this.tokenBearer = tokenBearer
  }
  async atualizarCompetencia (competencia, idsUnimed, reenviarComErro) {
    return new Promise(async (resolve, reject) => {
      let option = {
        method: 'PUT',
        url: `${this.url}`,
        headers: {
          Authorization: this.tokenBearer
        },
        data: {
          competencia: competencia,
          codigoUnimed: idsUnimed,
          reenviarComErro: reenviarComErro
        }
      }
      try {
        let response = await axios(option)
        resolve(response)
      } catch (error) {
        reject(error)
      }
    });
  }

  async consultarCompetenciaBeneficiariosCadbenef (competencia, idsUnimed, reenviarComErro) {
    return new Promise(async (resolve, reject) => {
      let option = {
        method: 'POST',
        url: `${this.url}`,
        headers: {
          Authorization: this.tokenBearer
        },
        data: {
          competencia: competencia,
          codigoUnimed: idsUnimed,
          reenviarComErro: reenviarComErro
        }
      }
      try {
        let response = await axios(option)
        resolve(response)
      } catch (error) {
        reject(error)
      }
    })
  }
}
